export function widthMeasures(state) {
  return state.widthMeasures
}

export function heightMeasures(state) {
  return state.heightMeasures
}

export function rimMeasures(state) {
  return state.rimMeasures
}
